mutation unsnoozeGrant($caseRecordId: ID!) {
  unsnoozeGrant(input: { caseRecordId: $caseRecordId }) {
    grantCaseRecord {
      id
    }
  }
}
